import { useState, useCallback, useEffect } from 'react';

import { useRecoilValue } from 'recoil';

import * as fp from 'lodash/fp';
import { PLATFORM_ID } from '~/globalVariables';

import { parsePhoneNumber } from 'libphonenumber-js/mobile';
import updatePlatformCustomer from '~/firebase/update/updatePlatformCustomer';
import auth from '~/recoil/atom/auth';
import customer from '~/recoil/atom/customer';

export default function usePhoneNumber() {
  const authUser = useRecoilValue(auth);
  const customerData = useRecoilValue(customer);

  const [phone, setPhone] = useState<string>(customerData?.phoneNumber || '');
  const [phoneError, setPhoneError] = useState(customerData.phoneNumber ? '' : '請輸入手機號碼');

  const handleUpdatePhone = useCallback(
    fp.debounce(700, async (phone: string) => {
      try {
        const parsed = parsePhoneNumber(phone, 'TW');
        setPhoneError(!parsed.isValid() ? '請輸入正確的手機號碼' : '');
        if (parsed.isValid() && authUser) {
          const parsedPhone = parsed.formatInternational().split(' ').join('');
          try {
            await updatePlatformCustomer(PLATFORM_ID, authUser, {
              phoneNumber: parsedPhone,
            });
            setPhone(parsedPhone);
          } catch (err) {
            console.error('update phone error', err);
          }
        }
      } catch (error) {
        console.error('update phone error', error);
        setPhoneError('請輸入正確的手機號碼');
      }
    }),
    [setPhoneError, authUser],
  );

  const handleChangePhone = (value: string) => {
    setPhone(value);

    if (authUser) {
      handleUpdatePhone(value);
    }
  };

  useEffect(() => {
    setPhone(customerData?.phoneNumber || '');
    setPhoneError(customerData.phoneNumber ? '' : '請輸入手機號碼');
  }, [customerData]);

  return {
    phone,
    phoneError,
    handleChangePhone,
  };
}
